export default "__VITE_ASSET__D4bYc67e__"